import React, { useState } from 'react';
import { useOtherStyles } from '../../App';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { blue } from '@material-ui/core/colors';
import ItemList from '../../common/List/ItemList';
import { LoadingProps, TeamMinimal } from '../../@types';
import { getTeams } from '../../axios/teams';
import AddIcon from '@material-ui/icons/Add';
import SubmitButton from '../../common/Button/SubmitButton';
import Dialog from '@material-ui/core/Dialog';
import CreateTeam from './CreateTeam';
import IsLoadingHOC from '../../IsLoadingHOC';

const useStyles = makeStyles({
	title: {
		color: 'black',
	},
	avatar: {
		backgroundColor: blue[500],
	},
	action: {
		padding: '20px 1vw 0px 0px',
		['@media (max-width:600px)']: {
			display: 'none',
		},
	},
	teamCard: {
		margin: '10px 5vw',
	},
	actionIcon: {
		padding: '20px',
	},
});

export const TeamSearchPage = (props: LoadingProps) => {
	const globalClasses = useOtherStyles();
	const [open, setOpen] = useState(false);
	
	const handleCreateNewItem = () => {
		// history.push(`/teams/new`);
		setOpen(true)
	};

	const handleClose = () => {
		setOpen(false)
	}
	const [teams, setTeams] = React.useState<TeamMinimal[]>([]);
	React.useEffect(() => {
		props.setLoading(true)
		getTeams()
			.then((res: any) => {
				props.setLoading(false)
				setTeams(res.data);
			})
			.catch((err: any) => {
				console.log(err)
				props.setLoading(false)
			});
	}, []);

	const handleSearch = () => {
		alert("Implement searching!")
	};

	return (
		<>
			<Typography align='center' variant='h4'>
				Teams
			</Typography>
			<Typography align='center' variant='subtitle2'>
				The active teams on COSINT
			</Typography>
			<hr className={globalClasses.hrDivider} />

			<ItemList name="teams" items={teams} />
			<SubmitButton
				icon={<AddIcon />}
				message={`Create a new team`}
				onClick={handleCreateNewItem}
				className={globalClasses.createItemButton}
			/>
			<Dialog
				open={open}
				fullWidth
				// className={classes.form}
				keepMounted
				onClose={handleClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<CreateTeam />
			</Dialog>
		</>
	);
};

export default IsLoadingHOC(TeamSearchPage);
